import React from 'react';
import {BrowserRouter as Router, Route, Switch, Link} from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Cart from './components/Cart';
import Completed from './components/Completed';
import { CartProvider } from './components/CartContext';
import Denied from './components/Denied';

const App = () => {
  return (
    <React.StrictMode>
      <CartProvider>
        <Router>
          <div className="app">
            <Switch>
              <Route exact path="/">
                <Header />
              </Route>
              <Route path="/cart">
                <Cart />
              </Route>
              <Route path="/completed">
                <Completed />
              </Route>
              <Route path="/*">
                <Denied />
              </Route>

            </Switch>
          </div>
        </Router>
      </CartProvider>
    </React.StrictMode>
  );
};

export default App;
